import { SHA256, enc } from "crypto-js";
import { SignJWT } from "jose";

const secretKey = new TextEncoder().encode(process.env.REACT_APP_SECRET_WIDGET);

const saltMaster = [
  "6683cf6486187363e4f0e4e1310b09490aaaab3155ec7130e181f944d68f8a30",
  "17820530fddf81cafe3a1e37941d80f44ca0deaa92b9ea036f38582ef88ac057",
  "5ff9aa4ca343f62b132e136628f2ba7f0407384c6bad59123f5d063ff86a1c3c",
  "46e67c525617663b392a53c0e94ba79e62db62a851fb175ae87756d4e73c9718",
  "cba9ebe84ae96b4dbe6f36f25e6842e712529d43d7aaac2e11bfba9965a14b42",
  "f65c4c5e38509d0cd05bcee72b6b69dd72b659289bf6747795fb02adda6db047",
  "8e7e3ff9c84fb08d79d6544ae6803a0a68df5677ca4ea055db6d4f8cca09c768",
  "169b032adf2ab80f3bdffbdf14358d9d72565fad7708f65c65cb4d7918a4ffb2",
  "4b85df16a17f41b4686bfd377dbefc4453f063ebc99ad54d91822509298b2baa",
  "dbc74a36d8e7439c45c64d856388506cc9b1218619cef979c3d605115a7a4546",
  "1031cef4492c584e86ed74bbcbf646b38f09b89b7245f9d58b14c105aba45ecf",
  "45d259c150b38f7411f93af791ecbb2d27e9251304a2c2a29343cf8f47ce9c67",
  "25f8a5cbead6f1fdfc2d38b2b7a922496fdb290ac95c31efbd5e522484274321",
  "3ce16d634539737e6902ffb43a0e3960662fe3109852640c0f4533cd3355e9fa",
  "35829f6598ea1848d05a97571c1232a10be553752e2888b462716370806343af",
  "eb3d8c08d045c3000dcc3e5ed0438e498413d6d2e5e40a58ee63ec57cc135546",
  "03192e3e0094dd6be3cce7bb0c766f781c3c0399a5ce148b074142c446650639",
  "5d4badfcc8fe408286a083126cf554c494f6e07bafac271dcbdf4d2a82922ef3",
  "6294dfccfe16a8eb778fd648bd89824249dc539b042dc500be5bd0e7cee17909",
  "31a5577d4b24d2f9c93411df2b918e372a81b5ad819b74c5749005c6c7dd8f70",
  "d322c3a9837fad6b52f61630ebd14ce83966c93c7d8b8248eb7b7b041c1c643f",
  "18f27e0f8b1c00c3ff1de09f2785d1d9be0d142e66875512da6d354986945e0b",
  "13909a7ca632d6123c86288d091924aebdea581ab2a1802f7ca082b179e10e0b",
  "95648b4276a5433d36acd80bbd898c5785b23a7ecc5f7a7c3cc20947e8d66ae1",
  "da55fa3ec91953e28588480e394adaceda059990d4ca0249e2ab084cb7f6c50c",
  "ed9ada05758c488f67a0c52b64dfe15864dada86a910efb58eaa651fc99dcc1f",
  "72644b48e024e5c8f8f4f864167e3f0ccff321463bf016207514aec4e146ca18",
  "de633760e6eb7e9b14324e3a91ed53c6df54d9792ce12f6c689b686f6f75f426",
  "3009be769fb8f956e8413ee9f3e0836e34968bc40457d0a10c549d2edcf00cc1",
  "3d143306cb1286cd576578771a64bad0caab653d6897f4dba8e7bf50240346d4",
  "3b0fe0d342e9fa16a5c68dbba33f2e63c024f72a9d4c1ce1028570101d5229ff",
  "18533ff99afd3cbcc17a1d2f44fbf77eb8efe606946a771e3d2016e271788973",
  "ec4f2dbb3b140095550c9afbbb69b5d6fd9e814b9da82fad0b34e9fcbe56f1cb",
  "7ab3a58f2c475f10b454472818a0e6d142f7d101eb577a4704884350aed1be6c",
  "3fa939242cb301ea9d935eff3a1d4b992c9f46d8cf8eecd0d68d18447ca521c5",
  "5ebfaaf103d47c70924fa49a7fb5ffa760492825817fcac554ba1a40fdba6560",
  "593b438726ec7de156a5ec03c90992bb0d97ab479f7cd2703c6c71c65b46b963",
  "f5b8c5e6f2dfb448339780d136be5f5fa259697237ea06b027b8ae007468718c",
  "d996290cefe24ca67633b6e67875ac4d0c28864f8c22cea208ab6378833153d0",
  "89d27c65efb4bcf8808bf690dc9ced8be8dc8cdc6c9b20b9a094bbbba619b265",
  "3ba324040e7d69aa1bd76948ac2f5a7cf20fafaf16424217009692d65349ce3e",
  "300af27a76175838a3df44a9ba1f9a66dcb63995420544fae4f9544ba970fe6b",
  "0a51c853eb1da966e2520b9937e9f5f8fc8f74336001fcddbdb8647d0a718fcb",
  "f2fb380c113e090af216f20cc9fc168b6e19e484b92229245f71d7ee55bc19b3",
  "8985ba498dba8e8b4ea258464128fa2062dedcca3eae4929fbe2cab4fa3d5f97",
  "4cc2dcce2ca875d74886b8ee6deb229cd0669113a406f96aef32ac507c85958f",
];

const concateSalt = (string) => {
  const salt = saltMaster[string.length % saltMaster.length];
  return string + salt;
};

export const hashString = (string, salted = true) => {
  let plaintext = string;
  if (salted) plaintext = concateSalt(string);
  // console.log(SHA256(plaintext).toString(enc.Hex));
  return SHA256(plaintext).toString(enc.Hex);
};

export const encodeJWT = async (payload) => {
  return await new SignJWT(payload)
    .setProtectedHeader({ alg: "HS256", typ: "JWT" })
    .sign(secretKey);
};
